import React, { Children } from "react";
import styled from "styled-components";
import { useFormContext } from "react-hook-form";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 10px;
`;
const Group = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  /* justify-content: space-between; */
  /* align-items: center; */
  gap: 15px;
`;

const GroupInput = styled.div`
  width: ${(props) => props.width || "300px"};
  height: 50px;
  background: #ffffff;
  border: 1.5px solid #e2e8f0;
  border-radius: 10px;
  padding: 10px 16px;
  font-size: 15px;
  box-sizing: border-box;
  transition: all 0.2s ease-in-out;
  &:focus-within {
    outline: none;
    border-color: #13cae9;
    box-shadow: 0 0 0 4px rgba(19, 202, 233, 0.1);
  }
`;

const Input = styled.input`
  width: ${(props) => props.width || "300px"};
  height: 50px;
  background: #f8fafc;
  border: 1.5px solid #e2e8f0;
  border-radius: 10px;
  padding: 10px 16px;
  font-size: 15px;
  box-sizing: border-box;
  color: #0f172a;
  transition: all 0.2s ease-in-out;
  &:focus {
    outline: none;
    background: #ffffff;
    border-color: #13cae9;
    box-shadow: 0 0 0 4px rgba(19, 202, 233, 0.1);
  }
`;

const Label = styled.label`
  font-weight: 600;
  font-size: 14px;
  text-transform: capitalize;
  color: #334155;
  margin-bottom: 2px;
`;

const Error = styled.p`
  font-family: "Cairo", sans-serif;
  color: #ef4444;
  font-size: 13px;
  margin-top: 4px;
`;

export default function InputGroup(props) {
  const { register } = useFormContext();
  return (
    <Container>
      <Group>
        <Label>{props.label}</Label>
        <Input
          {...props.input}
          {...register(props.name)}
          style={{
            backgroundColor: props.input?.background || "#FFFFFF", // ← استخدم backgroundColor
            ...props.input?.style,
          }}
        />
      </Group>
      {props.error ? <Error>{props.error.message}</Error> : null}
    </Container>
  );
}
export function FormGroup({ label, error, children }) {
  // const { register } = useFormContext();
  return (
    <Container>
      <Group>
        <Label>{label}</Label>
        {children}
      </Group>
      {error ? <Error>{error.message}</Error> : null}
    </Container>
  );
}
